import React, { useEffect, useState } from 'react';
import { message, Modal, Upload } from 'antd';
import { _T } from '../src/Localization';
import { getUrl } from '../scripts/cdn';
const MAX_UPLOAD_SIZE_MB = 25;
const ALLOWED_IMAGE_MIME_TYPES = new Set([
    'image/jpeg',
    'image/png',
    'image/heic',
    'image/heif'
]);
const ALLOWED_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.heic', '.heif'];
const getArrayBuffer = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
});
const getDataUrl = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
});
const toFileList = (value, size) => {
    if (value == null) {
        return [];
    }
    const normalizedValue = String(value).trim();
    if (!normalizedValue || normalizedValue === '0') {
        return [];
    }
    return [{
            uid: normalizedValue,
            url: getUrl('pics/' + normalizedValue + '/' + (size ? size : 'large')),
            name: normalizedValue
        }];
};
const ImageUpload = ({ value, onChange, size, disabled }) => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState(toFileList(value, size));
    useEffect(() => {
        setFileList(toFileList(value, size));
    }, [value, size]);
    const beforeUpload = async (file) => {
        const lowerName = String(file.name || '').toLowerCase();
        const hasAllowedExtension = ALLOWED_IMAGE_EXTENSIONS.some((extension) => lowerName.endsWith(extension));
        const hasAllowedMimeType = ALLOWED_IMAGE_MIME_TYPES.has(file.type);
        if (!hasAllowedMimeType && !hasAllowedExtension) {
            message.error(_T('image.incorrectFormat'));
            return;
        }
        const isLtMaxSize = file.size / 1024 / 1024 < MAX_UPLOAD_SIZE_MB;
        if (!isLtMaxSize) {
            message.error(_T('image.filesizeTooLarge'));
            return;
        }
        const result = await getArrayBuffer(file);
        onChange(result);
        return false;
    };
    const handleCancel = () => setPreviewOpen(false);
    const handlePreview = async (file) => {
        if (!file.url && !file.thumbUrl && !file.preview && file.originFileObj) {
            file.preview = await getDataUrl(file.originFileObj);
        }
        const source = file.url || file.thumbUrl || file.preview;
        if (!source) {
            message.error(_T('common.error'));
            return;
        }
        setPreviewImage(source);
        setPreviewOpen(true);
    };
    const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
    const handleRemove = () => {
        onChange(null);
        return true;
    };
    const uploadButton = (React.createElement("div", { style: { marginTop: 8 } }, _T('image.upload')));
    return (React.createElement(React.Fragment, null,
        React.createElement(Upload, { name: "avatar", listType: "picture-card", accept: "image/png, image/jpeg, image/heic, image/heif, .heic, .heif", disabled: disabled, beforeUpload: beforeUpload, onPreview: handlePreview, onChange: handleChange, fileList: fileList, maxCount: 1, onRemove: handleRemove }, uploadButton),
        React.createElement(Modal, { open: previewOpen, footer: null, onCancel: handleCancel },
            React.createElement("img", { alt: "example", style: { width: '100%' }, src: previewImage }))));
};
export default ImageUpload;
